import { render, staticRenderFns } from "./DataMatrixReader.vue?vue&type=template&id=75793714&scoped=true&"
import script from "./DataMatrixReader.vue?vue&type=script&lang=ts&"
export * from "./DataMatrixReader.vue?vue&type=script&lang=ts&"
import style0 from "./DataMatrixReader.vue?vue&type=style&index=0&id=75793714&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75793714",
  null
  
)

export default component.exports